// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
        emergentLink: 'home-emergent-link',
        // Shirt Happens scroll narrative
        navBrand: 'home-nav-brand',
        navCta: 'home-nav-cta',
        navShop: 'home-nav-shop',
        navCustom: 'home-nav-custom',
        navAbout: 'home-nav-about',
        scrollSection: 'home-scroll-section',
        phase1Hook: 'home-phase1-hook',
        phase2Mascot: 'home-phase2-mascot',
        phase2Bubble: 'home-phase2-bubble',
        phase3Pipe: 'home-phase3-pipe',
        phase4Shirt: 'home-phase4-shirt',
        phase5Cta: 'home-phase5-cta',
        ctaPrimary: 'home-cta-primary',
        // Shop
        shopSection: 'home-shop-section',
        shopCard: 'home-shop-card',
        shopBuyBtn: 'home-shop-buy-btn',
        shopSizePill: 'home-shop-size-pill',
        shopComingSoon: 'home-shop-coming-soon',
        // Custom request
        customSection: 'home-custom-section',
        customForm: 'home-custom-form',
        customName: 'home-custom-name',
        customEmail: 'home-custom-email',
        customIdea: 'home-custom-idea',
        customGarment: 'home-custom-garment',
        customShirtColor: 'home-custom-shirt-color',
        customSize: 'home-custom-size',
        customQuantity: 'home-custom-quantity',
        customTimeline: 'home-custom-timeline',
        customOccasion: 'home-custom-occasion',
        customAgree: 'home-custom-agree',
        customSubmit: 'home-custom-submit',
        customSuccess: 'home-custom-success',
        customError: 'home-custom-error',
        customReferenceDrop: 'home-custom-reference-drop',
        customReferenceFile: 'home-custom-reference-file',
        customReferenceRemove: 'home-custom-reference-remove',
        // Gallery
        gallerySection: 'home-gallery-section',
        galleryCard: 'home-gallery-card',
        galleryLightbox: 'home-gallery-lightbox',
        galleryClose: 'home-gallery-close',
        galleryEmpty: 'home-gallery-empty',
        navGallery: 'home-nav-gallery',
        // About
        aboutSection: 'home-about-section',
        // Who We Serve
        whoSection: 'home-who-section',
        whoCard: 'home-who-card',
        // FAQ
        faqSection: 'home-faq-section',
        faqItem: 'home-faq-item',
        // Footer
        footerDisclaimer: 'home-footer-disclaimer',
        // Gallery filter
        galleryFilter: 'home-gallery-filter',
        // Nav (extra)
        navFaq: 'home-nav-faq',
};

export const ADMIN = {
        loginForm: 'admin-login-form',
        loginPassword: 'admin-login-password',
        loginSubmit: 'admin-login-submit',
        loginError: 'admin-login-error',
        dashboard: 'admin-dashboard',
        statTotalRequests: 'admin-stat-total-requests',
        statNewRequests: 'admin-stat-new-requests',
        statTotalOrders: 'admin-stat-total-orders',
        statPaidOrders: 'admin-stat-paid-orders',
        statRevenue: 'admin-stat-revenue',
        tabRequests: 'admin-tab-requests',
        tabOrders: 'admin-tab-orders',
        tabPhotos: 'admin-tab-photos',
        tabAnalytics: 'admin-tab-analytics',
        requestRow: 'admin-request-row',
        orderRow: 'admin-order-row',
        statusSelect: 'admin-status-select',
        exportRequests: 'admin-export-requests',
        exportOrders: 'admin-export-orders',
        logout: 'admin-logout',
        photoAddOpen: 'admin-photo-add-open',
        photoUploadForm: 'admin-photo-upload-form',
        photoUploadFile: 'admin-photo-upload-file',
        photoUploadTitle: 'admin-photo-upload-title',
        photoUploadDescription: 'admin-photo-upload-description',
        photoUploadCategory: 'admin-photo-upload-category',
        photoUploadSubmit: 'admin-photo-upload-submit',
        photoUploadCancel: 'admin-photo-upload-cancel',
        photoRow: 'admin-photo-row',
        photoDelete: 'admin-photo-delete',
        convertOpen: 'admin-convert-open',
        convertDialog: 'admin-convert-dialog',
        convertAmount: 'admin-convert-amount',
        convertProduct: 'admin-convert-product',
        convertNotes: 'admin-convert-notes',
        convertSubmit: 'admin-convert-submit',
        convertCancel: 'admin-convert-cancel',
        convertedBadge: 'admin-converted-badge',
        unconvert: 'admin-unconvert',
        payLinkOpen: 'admin-paylink-open',
        payLinkDialog: 'admin-paylink-dialog',
        payLinkAmount: 'admin-paylink-amount',
        payLinkProduct: 'admin-paylink-product',
        payLinkMessage: 'admin-paylink-message',
        payLinkSubmit: 'admin-paylink-submit',
        payLinkCancel: 'admin-paylink-cancel',
        payLinkSentBadge: 'admin-paylink-sent-badge',
        deleteRequest: 'admin-delete-request',
        deleteOrder: 'admin-delete-order',
        // Reviews section
        reviewsSection: 'home-reviews-section',
        reviewCard: 'home-review-card',
        // Teeodore mascot section
        teeodoreSection: 'home-teeodore-section',
        teeodoreImage: 'home-teeodore-image',
        teeodoreStat: 'home-teeodore-stat',
        // Community wall
        communitySection: 'home-community-section',
        resetOpen: 'admin-reset-open',
        resetDialog: 'admin-reset-dialog',
        resetScopeAll: 'admin-reset-scope-all',
        resetScopeRequests: 'admin-reset-scope-requests',
        resetScopeOrders: 'admin-reset-scope-orders',
        resetConfirmInput: 'admin-reset-confirm-input',
        resetConfirm: 'admin-reset-confirm',
        resetCancel: 'admin-reset-cancel',
        emailTest: 'admin-email-test',
        emailTestResult: 'admin-email-test-result',
};
